<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <!--<NeList ref='neGms' :neArr='netype' :select='neClick'></NeList>-->
      <OrganizationalTree ref="organizationalTree" @qryNeids = 'qryNeidsChangeOfGroup' :nodeSelectProp='getNode' :neid="neid">
        <template v-slot:organizationalIcon_solt>
          <OrganizationalIcon ></OrganizationalIcon>
        </template>
      </OrganizationalTree>
    </template>
    <template v-slot:right_view>
      <GroupTableMenu @methodEnum='methodEnum'></GroupTableMenu>
      <GroupTable ref="grouptable" :qryNeids = 'qryNeids'></GroupTable>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../../layouts/BasicLayout';
import GroupTableMenu from '../../../../components/subscriberMicro/mcsSubscriber/group/GroupTableMenu';
import GroupTable from '../../../../components/subscriberMicro/mcsSubscriber/group/GroupTable';
// import NeList from '../../../../components/common/NeList';
import OrganizationalTree from '../../../../components/subscriberMicro/mcsSubscriber/OrganizationalTree';
import OrganizationalIcon from '../../../../components/subscriberMicro/mcsSubscriber/OrganizationalIcon';

export default {
  name: 'GroupMainPage',
  components: {
    BasicLayout,
    GroupTableMenu,
    GroupTable,
    // NeList,
    OrganizationalTree,
    OrganizationalIcon
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('SubscriberIms.organization')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t('SubscriberIms.menuTitleGroupMcs')
      },
      netype: [2142],
      qryNeids: []
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'add':
          this.$refs.grouptable.openAddGroupPage();
          break;
        case 'mod':
          this.$refs.grouptable.openModGroupPage();
          break;
        case 'del':
          this.$refs.grouptable.delGroups();
          break;
        case 'addGroupMember':
          this.$refs.grouptable.openAddGroupMemberPage();
          break;
        case 'groupArea':
          this.$refs.grouptable.openGroupAreaPage();
          break;
        case 'qryGroupMember':
          this.$refs.grouptable.openQryGroupMemberPage();
          break;
        case 'groupCall':
          this.$refs.grouptable.openGpsGroupCallPage();
          break;
        case 'refresh':
          this.$refs.grouptable.reFreshByNoCondition();
          break;
        case 'search':
          this.$refs.grouptable.openSuperSearchPage();
          break;
        case 'groupExport':
          this.$refs.grouptable.exportGroupData();
          break;
        case 'groupMemberExport':
          this.$refs.grouptable.exportGroupMemberData();
          break;
        default:
      }
    },
    neClick() {
      this.$refs.grouptable.getGridData(this.$refs.neGms.getNe());
    },
    getNode(node) {
      this.$refs.grouptable.getGridData(node);
      this.node = node;
    },
    qryNeidsChangeOfGroup(qryNeids) {
      this.qryNeids = qryNeids
    }
  },
  mounted() {
    this.$refs.organizationalTree.getOrganizationalTree();
  }
};
</script>

<style scoped>

</style>
